import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "ion-padding" }

import {
  IonButton,
  IonCard,
  IonContent,
  IonInput,
  IonItem,
  IonPage
} from "@ionic/vue";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import { showToast } from "@/utils";
import { translate } from "@/i18n";
import Logo from "@/components/Logo.vue";
import logger from "@/logger";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();

const username = ref("");
const password = ref("");
const instanceUrl = ref("");

const currentInstanceUrl = computed(() => store.getters["user/getInstanceUrl"]);

onMounted(() => {
  instanceUrl.value = currentInstanceUrl.value;
});

async function login() {
  try {
    const response: any = await store.dispatch("user/login", {
      username: username.value,
      password: password.value,
    });

    if(response.api_key) {
      username.value = "";
      password.value = "";
      router.push("/");
    }
  } catch (error) {
    logger.error("Login error: ", error);
    showToast(translate("Username or password is incorrect"));
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonCard), null, {
              default: _withCtx(() => [
                _createElementVNode("form", {
                  class: "form-card",
                  onKeyup: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])),
                  onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (login(_ctx.form)), ["prevent"]))
                }, [
                  _createVNode(Logo),
                  _createVNode(_unref(IonItem), { lines: "full" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "label-placement": "fixed",
                        label: (_unref(translate)('Username')),
                        modelValue: username.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                        type: "text",
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), { lines: "full" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "label-placement": "fixed",
                        label: (_unref(translate)('Password')),
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                        type: "password",
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(IonButton), {
                      type: "submit",
                      color: "primary",
                      expand: "block"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Login")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/forgetPassword'))),
                      color: "primary",
                      fill: "clear",
                      expand: "block"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Forget Password?")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 32)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButton), {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/register'))),
              color: "dark"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Register")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})